import { Injectable } from "@angular/core";
import { LaborListRequestModel, LaborDetailsViewModel } from "../business-entities/labor-details-view-model";
import { GenericResponse } from "../business-entities/generic-response";
import { LaborDataService } from "../data-services/labor-data.service";

@Injectable({
    providedIn: 'root'
})

export class LaborService {
    Id: number;
    logo: any;
    laborListRequest: LaborListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            statusId: 0,
            syncId: 0,
            cultureCode: '',
            sourceId : 0
        }
    selectedLaborList: LaborDetailsViewModel[];
    searchLabourNumber: string;
    dealerId: string = "";
    constructor(private service: LaborDataService) {
    }

    async getLaborList(requestModel: LaborListRequestModel): Promise<GenericResponse<any>> {
        return this.service.getLaborList(requestModel);
    }

    async getLaborById(Id: number) {
        return this.service.getLaborById(Id);
    }

    AddUpdateLabor(LaborModel: any): Promise<GenericResponse<any>> {
        return this.service.AddUpdateLabor(LaborModel);
    }
    async ResyncLabor(id: number): Promise<GenericResponse<any>> {
        return this.service.ResyncLabor(id);
    }
    async getSearchLabor(model: any): Promise<any> {
        return this.service.getSearchLabor(model)
    }
    async getChargingGroupDropDown(): Promise<any> {
        return this.service.getChargingGroupDropDown()
    }
}